export default "__VITE_ASSET__DYTRdPA2__"